import { render, staticRenderFns } from "./AutoComplete.vue?vue&type=template&id=bafb61ca&"
import script from "./AutoComplete.vue?vue&type=script&lang=js&"
export * from "./AutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports